import { createSlice } from '@reduxjs/toolkit'

export const leadSourceSlice = createSlice({
    name: 'leadSource',
    initialState: {
        leadsources: [],
    },
    reducers: {
        load: (state, action) => {
            state.leadsources = action.payload
        },
    }
})
export default leadSourceSlice.reducer

export const { load } = leadSourceSlice.actions

// export const selectRepsStatus = state => state.reps.repsStatus
// export const selectAllReps = state => state.reps.reps
export const getAllSources = (state) => state.leadSource.leadsources || [];
export const getSourceByID = (state, id) => state.leadSource.leadsources.find(ls => ls.ID === id);
// export const selectRepByID = (state, repID) => state.reps.reps.find(rep => rep.ID === repID)

